import * as tslib_1 from "tslib";
import styled, { withProps } from '../styles';
var getSizeStyle = function (sizeConfig, mediaQuery) {
    if (!sizeConfig) {
        return undefined;
    }
    var width = typeof sizeConfig === 'number' ? sizeConfig : sizeConfig.flex;
    var offset = typeof sizeConfig === 'number' ? 0 : sizeConfig.offset || 0;
    return "\n    @media screen and " + mediaQuery + " {\n      width: " + 100 / 24 * width + "%;\n      " + (offset && "margin-left: " + 100 / 24 * offset + "%;") + "\n    }\n  ";
};
var cssStyle = function (props) {
    return [
        getSizeStyle(props.xs, '(max-width: 600px)'),
        getSizeStyle(props.sm, '(min-width: 600px) and (max-width: 960px)'),
        getSizeStyle(props.md, '(min-width: 960px) and (max-width: 1280px)'),
        getSizeStyle(props.lg, '(min-width: 1280px) and (max-width: 1920px)'),
        getSizeStyle(props.xl, '(min-width: 1920px)'),
    ]
        .filter(Boolean)
        .join('');
};
/**
 * Grid布局中的列组件
 *
 * @ReactComponent
 */
var Column = withProps()(styled.div)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: block;\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  order: ", ";\n  ", ";\n  ", "\n  ", "\n  ", "\n"], ["\n  display: block;\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  order: ", ";\n  ", ";\n  ",
    "\n  ",
    "\n  ", "\n"])), function (props) { return "width: " + 100 / 24 * props.flex + "%"; }, function (props) { return props.offset && "margin-left: " + 100 / 24 * props.offset + "%"; }, function (props) { return props.order; }, cssStyle, function (props) {
    return props.flexContainer &&
        "\n    display: flex;\n  ";
}, function (props) {
    return props.justifyContent && "justify-content: " + props.justifyContent + ";";
}, function (props) { return props.alignItems && "align-items: " + props.alignItems + ";"; });
export default Column;
var templateObject_1;
//# sourceMappingURL=Column.js.map